export const jumpToPage = (data, callback) => {
    const type = data.type
    const canvas = document.getElementById(`${type}CanvasBox`)
    const pageNum = data.pageNum
    const pageTop = document.getElementById(`${type}Page${pageNum[0]}`).offsetTop
    const pageLeft = document.getElementById(`${type}Page${pageNum[0]}`).offsetLeft
    const result = {
        x: pageLeft + data.x - canvas.offsetWidth / 2 - canvas.offsetLeft,
        y: pageTop + data.y - canvas.offsetHeight / 2 - canvas.offsetTop,
    }
    canvas.scrollTo && canvas.scrollTo(result.x, result.y)
    // callback && callback()
}

export const scrollOnePx = () => {
    const baseCanvas = document.getElementById(`BaseCanvasBox`)
    const compareCanvas = document.getElementById(`CompareCanvasBox`)
    const baseScrollLeft = baseCanvas.scrollLeft
    const baseScrollTop = baseCanvas.scrollTop
    const compareScrollLeft = compareCanvas.scrollLeft
    const compareScrollTop = compareCanvas.scrollTop
    // const pageTop = document.getElementById(`${type}Page${pageNum[0]}`).offsetTop
    // const pageLeft = document.getElementById(`${type}Page${pageNum[0]}`).offsetLeft
    baseCanvas.scrollTo && baseCanvas.scrollTo(baseScrollLeft + 1, baseScrollTop + 1)
    compareCanvas.scrollTo && compareCanvas.scrollTo(compareScrollLeft + 1, compareScrollTop + 1)
    baseCanvas.scrollTo && baseCanvas.scrollTo(baseScrollLeft, baseScrollTop)
    compareCanvas.scrollTo && compareCanvas.scrollTo(compareScrollLeft, compareScrollTop)
    // callback && callback()
}

export const jumpToAlignment = (data, baseList, compareList) => {
    if (data.mapping === "Compare") {
        const canvas = document.getElementById(`CompareCanvasBox`)
        const pageNum = data.pageCompare[0]
        const pageTop = document.getElementById(`ComparePage${pageNum}`).offsetTop
        const pageLeft = document.getElementById(`ComparePage${pageNum}`).offsetLeft
        const result = {
            x: pageLeft + data.shapeFromPos.x - canvas.offsetWidth / 2 - canvas.offsetLeft,
            y: pageTop + data.shapeFromPos.y - canvas.offsetHeight / 2 - canvas.offsetTop,
        }
        // const result = {
        //     x: data.shapeFromPos.x - canvas.offsetWidth / 2 + data.shapeFromPos.width / 2,
        //     y: data.shapeFromPos.y - canvas.offsetHeight / 2 + data.shapeFromPos.height / 2,
        // }
        canvas.scrollTo && canvas.scrollTo(result.x, result.y)
    } else if (data.mapping === "Base") {
        const canvas = document.getElementById(`BaseCanvasBox`)
        const pageNum = data.pageBase[0]
        const pageTop = document.getElementById(`BasePage${pageNum}`).offsetTop
        const pageLeft = document.getElementById(`BasePage${pageNum}`).offsetLeft
        const result = {
            x: pageLeft + data.shapeFromPos.x - canvas.offsetWidth / 2 - canvas.offsetLeft,
            y: pageTop + data.shapeFromPos.y - canvas.offsetHeight / 2 - canvas.offsetTop,
        }
        canvas.scrollTo && canvas.scrollTo(result.x, result.y)
    }
}
export const handlePageJump = (ele, data, type) => {
    const mappingData = data[type]
    const followData = data[type === "Base" ? "Compare" : "Base"]
    if (data[type].follow) {
        ele.scrollTo &&
            ele.scrollTo(mappingData.mappingPos.x, mappingData.mappingPos.y - followData.blockVisualPos.height)
    } else {
        ele.scrollTo &&
            ele.scrollTo(
                mappingData.mappingPos.x - ele.offsetWidth / 2 + mappingData.mappingPos.width / 2,
                mappingData.mappingPos.y - ele.offsetHeight / 2 + mappingData.mappingPos.height / 2
            )
    }
}
